import { PageSizeEntry } from '@/core/util/page-size-store.interface';

export const PAGE_SIZE_FEATURE_CONFIG: PageSizeEntry = {
    defaultSize: 10,
    storageKey: 'mpp',
    separate: true
};
